import React from "react";
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import pillsStyle from "assets/jss/material-kit-react/views/componentsSections/pillsStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from 'components/CustomButtons/Button.jsx';
import Next from '@material-ui/icons/ArrowForward';

import image1 from "assets/img/24092018.png";
import image2 from "assets/img/28092018.png";
import image3 from "assets/img/14122018.png";
import image4 from "assets/img/01dec1918.png";
import image5 from "assets/img/07012019001.png";
import image6 from "assets/img/07012019003.png";
import image7 from "assets/img/fssc22000.png"
import image8 from "assets/img/feb112019.png"
import image9 from "assets/img/feb1120193.png"

import brochure01 from "assets/img/ISO_9001_SWASTA.jpg"
import brochure02 from "assets/img/ISO_22001_2018.jpg"
import brochure03 from "assets/img/ISO_45001.jpg"
import brochure04 from "assets/img/ISO 27001.jpg"
import brochure05 from "assets/img/persyaratan.pdf"

class SectionPills extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <div id="navigation-pills">
            {/* <div className={classes.title}>
              <h3>Navigation Pills</h3>
            </div>
            <div className={classes.title}>
              <h3>
                <small>With Icons</small>
              </h3>
            </div> */}
            <GridContainer justify="center" >
              <GridItem xs={12} sm={12} md={10} lg={10}>
                <NavPills
                  color="primary"
                  tabs={[
                    {
                      tabButton: "News Update",
                      // tabIcon: Schedule,
                      tabContent: (
                        <div>
                          <Card>
                            <CardBody>
                              <img src={image9} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>12 Februari 2019, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/12022019/Awareness-Training-System-ISO-45001"  className={classes.link}>
                                    Public Training 1.0: Awareness Training System ISO 45001:2018 & Occupational Safety and Health (SMK3)
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                              Pada hari kamis tanggal 7 Februari 2019 Sandton Consulting mengadakan program Public Training 1.0 yang diselenggarakan dengan tema “Awareness Training System ISO 45001:2018 & Occupational Safety and Health (SMK3)” bertempat di Satu Atap Co-Working Place and Food Street, Surabaya.
                              </p>
                              <Link to="/newsresources/12022019/Awareness-Training-System-ISO-45001"  className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <img src={image5} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>07 January 2019, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/07012019/SMK-PGRI-1-&-SMK-PGRI-3-:-Awareness-Training-ISO-9001:2015" className={classes.link}>
                                    SMK PGRI 1 & SMK PGRI 3: Awareness Training ISO 9001:2015
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                                SMK PGRI 1 dan SMK PGRI 3 Kota Serang, di Provinsi Banten merupakan sekolah menengah kejuruan swasta pertama yang memiliki sertifikat standar internasional ISO 9001:2015.  Kesadaran akan pentingnya sistem mutu manajemen yang berstandar internasional dalam sebuah organisasi membuat SMK PGRI 1 dan SMK PGRI 3 berani menerima tantangan untuk mengedepankan dan meningkatkan mutu manajemen juga mutu pendidikan sekolah tersebut sehingga SMK PGRI 1 dan SMK PGRI 3 saat ini berhasil menjadi sekolah favorit masyarakat Kota Serang.
                              </p>
                              <Link to="/newsresources/07012019/SMK-PGRI-1-&-SMK-PGRI-3-:-Awareness-Training-ISO-9001:2015" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <img src={image6} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>07 January 2019, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/24112018/PDAM-TIRTA-MUSI-:-Pelatihan-Sistem-Manajemen-Mutu-ISO-9001:2015" className={classes.link}>
                                    PDAM TIRTA MUSI: Pelatihan Sistem Manajemen Mutu ISO 9001:2015 
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                              PDAM TIRTA MUSI merupakan Perusahaan Air Bersih yang berada di kota Palembang, Sumatera Selatan. Perusahaan air bersih ini menjangkau seluruh wilayah kota Palembang dengan jumlah pelangan saat ini 281.462. PDAM Tirta Musi adalah satu-satunya sumber air bersih yang layak untuk minum dan masak bagi sebagian besar penduduk kota Palembang. Perusahaan ini memiliki 9 kantor unit pelayanan.
                              </p>
                              <Link to="/newsresources/24112018/PDAM-TIRTA-MUSI-:-Pelatihan-Sistem-Manajemen-Mutu-ISO-9001:2015" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <img src={image4} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>14 December 2018, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/24112018/in-house-training:-audit-internal-dan-kaji-ulang-manajemen-ISO-9001:2015" className={classes.link}>
                                    In House Training: Audit Internal dan Kaji Ulang Manajemen ISO 9001:2015
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                                PT. Sandton Sukses Bersama mendapat kepercayaan dari Dinas Peternakan dan Kesehatan Hewan Provinsi Jawa Tengah untuk melaksanakan In House Training dengan tema “Audit Internal dan Kaji Ulang Manajemen ISO 9001:2015”, bertempat di Boyolali pada tanggal 14 Mei 2018. Peserta training yang ikut serta adalah staff dan veterinarian dari Balai Veteriner Boyolali.
                            </p>
                              <Link to="/newsresources/24112018/in-house-training:-audit-internal-dan-kaji-ulang-manajemen-ISO-9001:2015" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                        </div>
                      )
                    },
                    {
                      tabButton: "Articles",
                      // tabIcon: Dashboard,
                      tabContent: (
                        <div>
                          <Card>
                            <CardBody>
                              <img src={image8} alt="pictureimage8" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>12 Februari 2019, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/12022019/Sistem-Manajemen-Keamanan-Informasi,-Kunci-Utama-Pertumbuhan-Bisnis-Masa-Kini" className={classes.link}>
                                    Sistem Manajemen Keamanan Informasi, Kunci Utama Pertumbuhan Bisnis Masa Kini
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                                Mengingat dewasa ini hampir semua infrastruktur keuangan dan jasa lainnya bergantung pada teknologi informasi, maka ancaman kerugian yang timbul jika terjadi ancaman siber di seluruh dunia pada tahun 2019 ini tidak akan kurang dari 30 kuadriliun rupiah. Sebuah angka yang amat besar mengingat ada 19 angka nol pada nominal tersebut. Sumber dari ancaman tersebut tidak hanya berasal dari komputer atau server yang menjadi tulang punggung penyedia jasa namun juga perangkat gawai yang kita pegang dan berbagai benda yang terkoneksi ke internet (Internet of Things). Perangkat apa pun yang secara terus menerus terhubung ke internet berpotensi untuk diretas oleh para hacker.
                              </p>
                              <Link to="/newsresources/12022019/Sistem-Manajemen-Keamanan-Informasi,-Kunci-Utama-Pertumbuhan-Bisnis-Masa-Kini" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <img src={image7} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>19 Januari 2019, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/19012019/Pentingnya-Manajemen-Keamanan-Pangan-FSSC-22000" className={classes.link}>
                                    Pentingnya Manajemen Keamanan Pangan FSSC 22000
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                                Mungkin kita akan menganggap biasa jika kita mengalami mual, pusing, atau diare sesudah mengkonsumsi produk makanan atau minuman tertentu. Namun demikian, gangguan kesehatan yang berasal dari produk yang kita konsumsi dapat mengganggu produktivitas kerja bahkan dalam taraf tertentu bisa menjadi kasus serius yang memerlukan penanganan medis yang jika terlambat bukan tidak mungkin mengakibatkan kematian.
                              </p>
                              <Link to="/newsresources/19012019/Pentingnya-Manajemen-Keamanan-Pangan-FSSC-22000" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <img src={image3} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>14 Desember 2018, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/24112018/resiko-dan-peluang-pada-ISO-9001:2015" className={classes.link}>
                                    Resiko dan Peluang pada ISO 9001:2015
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                                Banyak orang yang bertanya kenapa Standar ISO 9001 itu direvisi dan apa saja hal-hal baru yang muncul di revisi terbaru.
                              <br />
                                Sekedar informasi bahwa ISO 9001 telah direvisi sebanyak 4 kali (Revisi terakhir 2015) mulai dari ISO 9001 pertama kali terbit di tahun 1987.
                              </p>
                              <Link to="/newsresources/24112018/resiko-dan-peluang-pada-ISO-9001:2015" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <img src={image2} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>28 September 2018, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/28112018/ISO-27001-sistem-manajemen-keamanan-informasi" className={classes.link}>
                                    ISO 27001 (SISTEM MANAJEMEN KEAMANAN INFORMASI)
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                                Suatu instrumen penting bagi produk, jasa dan sistem yang ingin bersaing secara global. Standar ISO adalah salah satu standar internasional dalam sebuah Sistem Manajemen Mutu (SMM) yang digunakan untuk mengukur mutu organisasi. Standar ISO memegang peranan penting dalam mengukur bagaimana kredibilitas perusahaan yang ingin bersaing secara global dan juga adalah salah satu cara untuk meningkatkan sistem manajemen mutunya.
                              </p>
                              <Link to="/newsresources/28112018/ISO-27001-sistem-manajemen-keamanan-informasi" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <img src={image1} alt="pictureimage" style={{ width: 200, height: 150, marginRight: 15, float: 'left' }} />
                              <b>24 September 2018, 08.00 PM</b>
                              <h3 style={{ marginTop: 0 }}>
                                <b>
                                  <Link to="/newsresources/24112018/ISO-45001:2018-pengganti-OHSAS-18001:2007" className={classes.link}>
                                    ISO 45001:2018 Pengganti OHSAS 18001:2007
                                  </Link>
                                </b>
                              </h3>
                              <p style={{ fontSize: 16 }}>
                                Penerapan ISO 45001 membawa banyak manfaat bagi organisasi. Jumlah organisasi yang telah menerapkan OHSAS 18001 (pendahulu ISO 45001) sudah banyak dan masih terus bertambah. ISO 45001 membawa semua manfaat yang diberikan OHSAS 18001 dengan beberapa penambahan yang baru. Berikut beberapa diantaranya:
                              </p>
                              <Link to="/newsresources/24112018/ISO-45001:2018-pengganti-OHSAS-18001:2007" className={classes.link}>
                                <Button style={{ marginTop: 0, float: 'right' }} color="primary" simple ><b> Selengkapnya &nbsp;<Next /></b></Button>
                              </Link>
                            </CardBody>
                          </Card>
                        </div>
                      )
                    },
                    {
                      tabButton: "Resources",
                      // tabIcon: Schedule,
                      tabContent: (
                        <Card>
                          <CardBody>
                            <span>
                              <h3><b>Brochures Download</b></h3>
                              <ul style={{ fontSize: 20 }} >
                                <li><a href={brochure01} download><b>ISO 9001</b></a></li>
                                <li><a href={brochure02} download><b>ISO 22001 - 2018</b></a></li>
                                <li><a href={brochure03} download><b>ISO 45001</b></a></li>
                                <li><a href={brochure04} download><b>ISO 27001</b></a></li>
                              </ul>
                              <h3><b>Standard Requirements Download</b></h3>
                              <ul style={{ fontSize: 20 }} >
                                <li><a href={brochure05} download><b>PERSYARATAN STANDAR ISO 9001 SISTEM MANAJEMEN MUTU</b></a></li>
                              </ul>
                            </span>
                          </CardBody>
                        </Card>
                      )
                    }
                  ]}
                />
              </GridItem>
              {/* <GridItem xs={12} sm={12} md={12} lg={6}>
                <NavPills
                  color="rose"
                  horizontal={{
                    tabsGrid: { xs: 12, sm: 4, md: 4 },
                    contentGrid: { xs: 12, sm: 8, md: 8 }
                  }}
                  tabs={[
                    {
                      tabButton: "Dashboard",
                      tabIcon: Dashboard,
                      tabContent: (
                        <span>
                          <p style={{fontSize: 18}}>
                            Collaboratively administrate empowered markets via
                            plug-and-play networks. Dynamically procrastinate
                            B2C users after installed base benefits.
                          </p>
                          <br />
                          <p style={{fontSize: 18}}>
                            Dramatically visualize customer directed convergence
                            without revolutionary ROI. Collaboratively
                            administrate empowered markets via plug-and-play
                            networks. Dynamically procrastinate B2C users after
                            installed base benefits.
                          </p>
                          <br />
                          <p style={{fontSize: 18}}>
                            Dramatically visualize customer directed convergence
                            without revolutionary ROI. Collaboratively
                            administrate empowered markets via plug-and-play
                            networks. Dynamically procrastinate B2C users after
                            installed base benefits.
                          </p>
                        </span>
                      )
                    },
                    {
                      tabButton: "Schedule",
                      tabIcon: Schedule,
                      tabContent: (
                        <span>
                          <p style={{fontSize: 18}}>
                            Efficiently unleash cross-media information without
                            cross-media value. Quickly maximize timely
                            deliverables for real-time schemas.
                          </p>
                          <br />
                          <p style={{fontSize: 18}}>
                            Dramatically maintain clicks-and-mortar solutions
                            without functional solutions. Dramatically visualize
                            customer directed convergence without revolutionary
                            ROI. Collaboratively administrate empowered markets
                            via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base
                            benefits.
                          </p>
                        </span>
                      )
                    }
                  ]}
                />
              </GridItem> */}
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(pillsStyle)(SectionPills);



// WEBPACK FOOTER //
// ./src/views/News/Sections/SectionPills.jsx